import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
// @mui
import { Button, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { PageNotFoundIllustration } from '../assets/illustrations';
// locales
import { useLocales } from '../locales';
// context
import { useAuthContext } from '../auth/useAuthContext';
// vars
import { RAINBOW_VAR } from '../config';


// ----------------------------------------------------------------------

export default function ErrorPage() {
  const { error } = useAuthContext();
  const { translate } = useLocales();

  let message1 = "";
  let message2 = "";
  let message3 = "";
  let messOnBtn2 = "";
  let button1 = null;

  let goToSupport = () => {
    window.open("https://support.openrainbow.com/", '_blank');
  }

  if (error && error.status === 404) {
    message1 = translate('page404.notFoundSorry');
    message2 = translate('page404.notFoundMessage');
    message3 = translate('page404.networkIssue');
    messOnBtn2 = translate('page404.login');
    button1 = <Button onClick={goToSupport} size="large" variant="contained" sx={{marginRight: 3}}>{translate('page404.contact')}</Button>;
  } else if (error && error.message === 'Network Error') {
    message1 = translate('noServer.inaccessibleSorry');
    message2 = translate('noServer.noServerMessage');
    message3 = translate('noServer.requestIssue');
    messOnBtn2 = translate('noServer.login');
    button1 = <Button onClick={goToSupport} size="large" variant="contained" sx={{marginRight: 3}}>{translate('page404.contact')}</Button>;
  } else if (error && error.status === 401) {
    message1 = translate('page401.inaccessibleSorry');
    message2 = translate('page401.unauthorizedMessage');
    message3 = translate('page401.requestIssue');
    messOnBtn2 = translate('page401.login');
    button1 = <Button onClick={goToSupport} size="large" variant="contained" sx={{marginRight: 3}}>{translate('page404.contact')}</Button>;
  } else {
    message1 = translate('page404.notFoundSorry');
    message2 = translate('page404.notFoundMessage');
    message3 = translate('page404.urlMistyped');
    messOnBtn2 = translate('page404.home');
  }

  


  return (
    <>
      <Helmet>
        <title> Error Page Not Found | Rainbow Exporter </title>
      </Helmet>

      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            {message1}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            {message2}
            <br></br>
            {message3}
          </Typography>
        </m.div>

        <br /><br />

        <m.div variants={varBounce().in}>
          <PageNotFoundIllustration
            error={error}
            sx={{
              height: 260,
              my: { xs: 5, sm: 10 },
            }}
          />
        </m.div>

        <br /><br />
        
        {button1 &&
          <>
            {button1}
          </>
        }
        <Button href={RAINBOW_VAR.appOAuthRedirectUri} size="large" variant="contained">{messOnBtn2}</Button>
      </MotionContainer>
    </>
  );
}
